import { TRANS_WEBP_STR } from '@commonPackage/components';

export type TechItem = {
  title: string;
  brief: string;
  image: string;
  video?: string;
  bg: string;
};

export const COUNT_LIST = [
  {
    start: 100,
    number: 160,
    unit: '+',
    desc: '顶会论文',
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezd1d96_613722.png?${TRANS_WEBP_STR}`,
  },
  {
    start: 300,
    number: 400,
    unit: '项+',
    desc: '发明专利',
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezd68m9_840993.png?${TRANS_WEBP_STR}`,
  },
  {
    start: 10,
    number: 20,
    unit: '项+',
    desc: '政府背书',
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezd6nsg_860656.png?${TRANS_WEBP_STR}`,
  },
  {
    start: 10,
    number: 60,
    unit: '项+',
    desc: '行业荣誉',
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezd6wpa_872206.png?${TRANS_WEBP_STR}`,
  },
];
export const TECH_LIST_PC: TechItem[] = [
  {
    title: 'ACE引擎',
    brief:
      '网易伏羲自研分布式引擎，深度集成了多种 AI 技术和构建虚拟世界的能力，使用户能够高效搭建云端虚拟交互应用。Actor 编程模型，大大降低了分布式开发的复杂度，结合自动扩缩容能力，让举办超大型活动变得游刃有余。',
    video: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7surufc_662920.mp4',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5a_407550.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbptky_395394.png?${TRANS_WEBP_STR}`,
  },
  {
    title: 'AI捏脸',
    brief: '基于人脸照片进行特征分析，利用深度学习算法重建人脸的三维信息，快速创建专属虚拟形象。',
    video: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7surrnq_659333.mp4',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5e_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlc_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: 'AIGC服装生成',
    brief:
      '网易伏羲基于自建数据集，构建可以更好理解中文用户的多模态理解基础模型，以此作为基础实现面向元宇宙场景的开放式生成模型训练，实现通过文本输入生成不同服装，为元宇宙用户提供更加开放的互动体验。',
    image: 'https://static.fuxi.netease.com/yaotai/portal/index/lfusxn52_765221.png',
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlb_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '表情动作实时捕捉',
    brief:
      '通过摄像头检测用户面部表情、肢体、手势动作，根据人脸关键点和动作变化计算，生成 3D 表情系数和动作数据，实现真人与虚拟分身表情动作实时同步。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5d_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdla_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '三维场景重建',
    brief:
      '基于神经隐式场重建 SDF 表示的三维几何，再映射到三维网格表示；基于 Patch 优化从每张图提取质量最高的局部纹理像素块，再融合成完整纹理贴图，可以低成本、大批量地创建三维虚拟场景。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5c_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlb_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '万人同屏渲染',
    brief:
      '基于4级LOD、AOI和impostor技术，突破角色渲染所带来的性能瓶颈，实时同步来自于其他节点用户的状态、角色的服装，在万人同屏的场景下也能保证高精度的渲染。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5b_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdla_467981.png?${TRANS_WEBP_STR}`,
  },
];

export const TECH_LIST_MOBILE: TechItem[] = [
  {
    title: 'ACE引擎',
    brief:
      '网易伏羲自研分布式引擎，深度集成了多种 AI 技术和构建虚拟世界的能力，使用户能够高效搭建云端虚拟交互应用。Actor 编程模型，大大降低了分布式开发的复杂度，结合自动扩缩容能力，让举办超大型活动变得游刃有余。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5a_407550.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbptky_395394.png?${TRANS_WEBP_STR}`,
  },
  {
    title: 'AI捏脸',
    brief: '基于人脸照片进行特征分析，利用深度学习算法重建人脸的三维信息，快速创建专属虚拟形象。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5e_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlc_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: 'AIGC服装生成',
    brief:
      '网易伏羲基于自建数据集，构建可以更好理解中文用户的多模态理解基础模型，以此作为基础实现面向元宇宙场景的开放式生成模型训练，实现通过文本输入生成不同服装，为元宇宙用户提供更加开放的互动体验。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lfusxn52_765221.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlb_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '表情动作实时捕捉',
    brief:
      '通过摄像头检测用户面部表情、肢体、手势动作，根据人脸关键点和动作变化计算，生成 3D 表情系数和动作数据，实现真人与虚拟分身表情动作实时同步。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5d_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdla_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '三维场景重建',
    brief:
      '基于神经隐式场重建 SDF 表示的三维几何，再映射到三维网格表示；基于 Patch 优化从每张图提取质量最高的局部纹理像素块，再融合成完整纹理贴图，可以低成本、大批量地创建三维虚拟场景。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5c_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdlb_467981.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '万人同屏渲染',
    brief:
      '基于4级LOD、AOI和impostor技术，突破角色渲染所带来的性能瓶颈，实时同步来自于其他节点用户的状态、角色的服装，在万人同屏的场景下也能保证高精度的渲染。',
    image: `https://static.fuxi.netease.com/yaotai/portal/index/lez9xs5b_407551.png?${TRANS_WEBP_STR}`,
    bg: `https://static.fuxi.netease.com/yaotai/portal/index/lezbrdla_467981.png?${TRANS_WEBP_STR}`,
  },
];
